module.exports = "/_next/static/images/17634aa3688648cef868518362ba0208-cartao-proximo-ao-olho-lg@2x.jpg.webp";